import * as React from 'react';

import { darken } from 'polished';
import styled from 'styled-components';

import { COLOR, FONT_SIZE } from '../../../../packages/constants';

export interface TabButtonProps {
    onClick?: (e: any) => void;
    dataId: string;
    children: React.ReactNode;
    selected: boolean;
    value: string;
}

const StyledTabButton = styled.button.attrs<TabButtonProps>(({ dataId }) => ({
    'data-test-id': dataId,
}))<TabButtonProps>`
    border: 2px solid ${COLOR.MAIN.MEDIUM_GREY};
    padding: 9px 12px;
    font-size: ${FONT_SIZE.SMALL};
    font-weight: 700;
    line-height: 1.2;
    background-color: ${(props) => (props.selected ? COLOR.PRIMARY.WHITE : darken(0.05, COLOR.PRIMARY.WHITE))};
    color: ${COLOR.PRIMARY.BLACK};
    cursor: pointer;
`;

export const TabButton = React.forwardRef<HTMLButtonElement, TabButtonProps>(({ children, ...props }, ref) => (
    <StyledTabButton ref={ref} {...props}>
        {children}
    </StyledTabButton>
));
TabButton.displayName = 'TabButton';
